import { render, staticRenderFns } from "./IntegrationEligibilityTransportation.vue?vue&type=template&id=0bb815db&scoped=true&"
import script from "./IntegrationEligibilityTransportation.vue?vue&type=script&lang=js&"
export * from "./IntegrationEligibilityTransportation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb815db",
  null
  
)

export default component.exports